var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var Svg88ArmyGames = function Svg88ArmyGames(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.76L2 8.76001V5.23999L13.76 17L12 18.76Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.76L22 8.76001V5.23999L10.24 17L12 18.76Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.64892 5.23976L4.17297 9.7157L5.93365 11.4764L10.4096 7.00043L8.64892 5.23976Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.64044 5.2392L6.87976 6.99988L14.2195 14.3396L15.9801 12.5789L8.64044 5.2392Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3458 5.24426L13.5851 7.00494L18.061 11.4809L19.8217 9.72018L15.3458 5.24426Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3561 5.23599L8.01636 12.5757L9.77703 14.3364L17.1167 6.99666L15.3561 5.23599Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg88ArmyGames, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCiAgPHBhdGggZD0iTTEyIDE4Ljc2TDIgOC43NjAwMVY1LjIzOTk5TDEzLjc2IDE3TDEyIDE4Ljc2WiIgLz4NCiAgPHBhdGggZD0iTTEyIDE4Ljc2TDIyIDguNzYwMDFWNS4yMzk5OUwxMC4yNCAxN0wxMiAxOC43NloiIC8+DQogIDxwYXRoIGQ9Ik04LjY0ODkyIDUuMjM5NzZMNC4xNzI5NyA5LjcxNTdMNS45MzM2NSAxMS40NzY0TDEwLjQwOTYgNy4wMDA0M0w4LjY0ODkyIDUuMjM5NzZaIiAvPg0KICA8cGF0aCBkPSJNOC42NDA0NCA1LjIzOTJMNi44Nzk3NiA2Ljk5OTg4TDE0LjIxOTUgMTQuMzM5NkwxNS45ODAxIDEyLjU3ODlMOC42NDA0NCA1LjIzOTJaIiAvPg0KICA8cGF0aCBkPSJNMTUuMzQ1OCA1LjI0NDI2TDEzLjU4NTEgNy4wMDQ5NEwxOC4wNjEgMTEuNDgwOUwxOS44MjE3IDkuNzIwMThMMTUuMzQ1OCA1LjI0NDI2WiIgLz4NCiAgPHBhdGggZD0iTTE1LjM1NjEgNS4yMzU5OUw4LjAxNjM2IDEyLjU3NTdMOS43NzcwMyAxNC4zMzY0TDE3LjExNjcgNi45OTY2NkwxNS4zNTYxIDUuMjM1OTlaIiAvPg0KPC9zdmc+";
export { ForwardRef as ReactComponent };